import { useEffect, useState } from 'react';
import { getDepartments } from '../../../services/general';

const useDepartments = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null)

  useEffect(() => {

    setData();
    setIsLoading(true);
    getDepartments()
      .then(response => {
        setData(response);
      })
      .catch(error => {
        setError(error)
      })
      .finally(() => {
        setIsLoading(false);
      })
  }, [])

  return { data, error, isLoading };
};

export default useDepartments;